import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";

export default function useGetProfilePicture(userId) {
  const { data, error, mutate, isLoading } = useSWR(
    `${apiBaseURL}/api/user/Profile?userid=${userId}`,
    {
      onSuccess: (data) => console.log("useGetProfilePicture:", data?.data),
      revalidateOnFocus: false,
      dedupingInterval: 300000,
    },
  );
  const userPicture = data?.data;
  return {
    userPicture,
    error,
    mutate,
    isLoading,
  };
}
